import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { getProfile } from "../../../Redux/custmoer_auth/slice";
import { setCookie } from "../../../utility/setCookie";
import { toast } from "react-toastify";

const LoginasAdmin = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const token = searchParams.get("token");

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loginProcess = async () => {
      if (!token) {
        toast.error("Invalid or missing access token.", { autoClose: 3000 });
        navigate("/SignIn");
        return;
      }

      // Clear all existing session data so the previous user's state doesn't bleed in
      localStorage.clear();
      sessionStorage.clear();
      setCookie("access_token", "", -1);
      setCookie("refresh_token", "", -1);

      // Set new access token from params
      setCookie("access_token", token, 7);

      // Fetch profile using the new token to confirm validity
      try {
        const resultAction = await dispatch(getProfile());
        if (getProfile.fulfilled.match(resultAction as any)) {
          toast.success("Successfully logged in as Customer");
          navigate("/HomePage");
        } else {
          toast.error("Failed to fetch user profile using provided token.", {
            autoClose: 3000,
          });
          navigate("/SignIn");
        }
      } catch (err) {
        toast.error("Failed to login securely.");
        navigate("/SignIn");
      } finally {
        setIsLoading(false);
      }
    };

    loginProcess();
  }, [token, dispatch, navigate]);

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <div className="text-center p-5 bg-white shadow rounded">
        {isLoading ? (
          <>
            <div
              className="spinner-border text-dark mb-3"
              role="status"
              style={{ width: "3rem", height: "3rem" }}
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            <h4>Securely Logging you in as customer...</h4>
            <p className="text-muted">
              Please wait while we establish your session.
            </p>
          </>
        ) : (
          <h4>Redirecting...</h4>
        )}
      </div>
    </div>
  );
};

export default LoginasAdmin;
